import { memo, useMemo } from "react";
import { Dropdown, Grid } from "semantic-ui-react";

import { COMPANY_LOGO } from "../../config/constants";
import { FEATURES, SCOPES } from "../../config/permission-maps";
import { getCompanyId } from "../../utils/cacheStorage";
import { hideSearchPath } from "../../utils/utils";
import { NotificationDropdown } from "../notification/NotificationDropdown";
import PermissionsGate from "../PermissionGate";
import { DropDown } from "../selectDropDown/DropDown";
import "./Header.scss";

export const HeaderWebView = memo(
  ({
    options,
    userImage,
    navigate,
    company,
    getSearchValue,
    loadCompanyData,
    loadCompanyToken,
    searchCompany,
    notificationData,
    onClickNotification
  }: any) => {
    const pathname = window.location.pathname;
    const companyId = useMemo(() => getCompanyId(), [searchCompany]);

    return (
      <div className="mainContent">
        <Grid verticalAlign="middle" className="headerDefaultView" centered>
          <Grid.Column computer={4} className="rightContent" only="computer">
            <div onClick={() => navigate("/")}>
              <img src={COMPANY_LOGO} alt="logo" className="logo" />
            </div>
          </Grid.Column>

          <Grid.Column computer={12} only="computer" className="mainCenterView">
            <div className="headerRightView">
              <PermissionsGate
                scopes={[SCOPES.canAccessInHeaderMenu]}
                feature={FEATURES.companySearch}
              >
                {hideSearchPath(pathname) ? (
                  <>
                    <div className="webSerachDiv">
                      <DropDown
                        placeholder="Select Company"
                        currentData={company}
                        defaultValue={companyId}
                        onFocus={() => searchCompany("")}
                        handleChangeState={(e, data) => {
                          const companyDetails = company?.find(
                            (companyData: any) => companyData.key === data.value
                          )?.other;
                          getSearchValue(companyDetails);
                        }}
                        onSearchChange={(e, data) => {
                          searchCompany(data.searchQuery);
                        }}
                        loading={loadCompanyData}
                        search
                        testId="company-select-dropdown"
                        onBlur={() => searchCompany("")}
                      />
                    </div>
                    <NotificationDropdown
                      notification={notificationData}
                      onClick={onClickNotification}
                    />
                  </>
                ) : null}
              </PermissionsGate>
              <Dropdown trigger={userImage} options={options} pointing="top left" icon={null} />
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
);
